import React, { Component } from 'react'
import firebase from 'firebase'
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth'

import { db } from './firebase.js'
import { Card, Rules, Legend, Loading } from './Components'
import fullstackLogo from './images/fullstackLogo.png'
import graceHopperLogo from './images/graceHopperLogo.png'
import './App.css'


export default class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isSignedIn: false,
      currentUser: {},
      userProgress: {},
      loading: true,
      legendObjectives: {},
    }
    this.fetchObjectives = this.fetchObjectives.bind(this)
    this.fetchOrCreateUser = this.fetchOrCreateUser.bind(this)
  }

  uiConfig = {
    signInFlow: 'popup',
    signInOptions: [firebase.auth.GithubAuthProvider.PROVIDER_ID],
    callbacks: {
      signInSuccess: () => false,
    },
  }

  componentDidMount() {
    firebase.auth().onAuthStateChanged(user => {
      this.setState({
        isSignedIn: !!user,
        currentUser: user,
      })
      this.fetchOrCreateUser(user.uid)
    })
    this.fetchObjectives()
  }

  fetchObjectives() {
    db.collection('objectives')
    .get()
    .then(snapshot => {
      const legendObjectives = snapshot.docs.map(doc => {
        const data = doc.data()
        const docKeys = Object.keys(data)
        return {
          [doc.id]: docKeys.map(key => Object.assign({}, data[key], {key}))
        }
      })
      this.setState({ legendObjectives })
    })
    .then(() => this.setState({ loading: false }))
    .catch(err => console.error(err))
  }

  fetchOrCreateUser(userId) {

    let initObjectivesKeys = {}
    'GRACE'.split('').forEach(letter => {
      for (let i = 1; i <= 5; i++) {
        letter + i === 'A3'
        ? initObjectivesKeys[letter + i] = true
        : initObjectivesKeys[letter + i] = false
      }
    })

    const studentsCol = db.collection('students')
    studentsCol.doc(userId)
    .get()
    .then(doc => {
      if (!doc.exists) {
        // User doesn't exist. Create user and initialize objective keys set to false.
        studentsCol.doc(userId).set(initObjectivesKeys)
        this.setState({
          userProgress: initObjectivesKeys
        })
      } else {
        // User exists. Fetch objectives OR just *listen* on change.
        this.setState({
          userProgress: doc.data()
        })
      }
    })
    .catch(err => console.error(err))

  }

  render() {

    const { isSignedIn, loading, currentUser, userProgress, legendObjectives } = this.state

    return (
      <div className="App">
        <header className="App-header">
          <img className="App-logo" src={graceHopperLogo} alt="" />
          <h1 className="App-title">GRACE Card</h1>
          <img className="App-logo" src={fullstackLogo} alt="" />
        </header>

        {!isSignedIn
          ? ( <StyledFirebaseAuth
                uiConfig={this.uiConfig}
                firebaseAuth={firebase.auth()}
              />
            )
          : loading && !loading
            ? <p>Loading...</p>
            : ( <div>
                  <div className="welcomeContainer">
                    <p>
                      Welcome, {
                        currentUser.displayName
                        ? currentUser.displayName.split(' ')[0]
                        : currentUser.email
                      }!
                    </p>
                    <div className="buttonContainer">
                      <button className="button" onClick={() => firebase.auth().signOut()}><span>Sign Out</span></button>
                    </div>
                  </div>
                  {!Object.keys(userProgress).length
                    ? <Loading />
                    : (
                      <Card
                        userProgress={userProgress}
                        currentUser={currentUser}
                      />
                    )
                  }
                  <Rules />
                  <Legend
                    fetchedObjectives={legendObjectives}
                    loading={loading}
                  />
                </div>
              )
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App.js